/**
 * Checks if sessionStorage is available and sets the value for the key 'pdp-estimated-arrival' to the provided status.
 *
 * @param {string} status - The estimated arrival status to be stored.
 */
export const setSessionEstimatedArrivalStatus = (status) => {
  if (typeof sessionStorage !== "undefined" && typeof status === "string") {
    sessionStorage.setItem("pdp-estimated-arrival", status);
  }
};

/**
 * Retrieves the estimated arrival status from sessionStorage.
 *
 * Checks if sessionStorage is available and attempts to retrieve the
 * value for the key 'pdp-estimated-arrival'. If sessionStorage is not available or
 * the key does not exist, the function returns null.
 *
 * @returns {string|null} The estimated arrival status or null if not found or if sessionStorage is unavailable.
 */
export const getSessionEstimatedArrivalStatus = () => {
  if (typeof sessionStorage !== "undefined") {
    return sessionStorage.getItem("pdp-estimated-arrival");
  }
  return null;
};

export default {};
